<template>
    <div class="page" v-wechat-title="title">
      <wx-open-launch-weapp id="launch-btn" username="gh_8de940b01a61" :path="`pages/news-detail/news-detail?url=${link}`" v-if="isWechatBrowser && !!link">
                        <script type="text/wxtag-template">
                          <style>
                            .btn2 {
                              width: 100vw;
                              height: 100%;
                            }
                          </style>
                          <div class="btn2"> </div>
                        </script>
      </wx-open-launch-weapp>
      <img @click="handleClickImageToMiniApp" :src="mImgSrc" alt=""  style="margin: 0 auto; width: 100%; -webkit-touch-callout : none;">
      <div v-if="btnImgSrc" class="footer-btn-box">
        <img @click="handleClickImageToMiniApp" :src="btnImgSrc" alt="">
      </div>
    </div>
</template>

<script>
  import {envMixin} from "../../assets/js/mixin/global";
  import {H5InteractionAppMethodNames} from "../../assets/js/constants";

  export default {
    name: "landing-page",
    data () {
      return {
        title: '超级简历 WonderCV',
        mImgSrc: null, // 移动端 图
        btnImgSrc: null,
        link: 'https://mp.weixin.qq.com/s/bPyJPMIKS_6UIFSsaysiaA' // 跳转地址
      }
    },
    mixins:[ envMixin],
    created () {
      const { token } = this.$route.params
      this.getLandingPageDataFunc(token)
    },
    mounted() {
     setTimeout(()=>{
       let  btn = document.getElementById('launch-btn');
       console.log(btn)
       if(btn){
         btn.addEventListener('launch', function (e) {
           console.log('success');
         });
         btn.addEventListener('error', function (e) {
           console.log('fail', e.detail);
         });
       }
     },500)
    },
    methods: {
      handleClickImageToMiniApp(){
        if(this.isAppEnv){
          let appParams = {
              type: 'openMiniApp',
              data: {url: this.link},
          }
          window.ReactNativeWebView.postMessage(JSON.stringify(appParams))
        }
      },
      async getLandingPageDataFunc (token) {
        try {
          let params = {
            token
          }
          let res = await this.$api.global.getLandingPageData(params)
          if (res.code === 1000) {
            this.title = res.data.title
            this.mImgSrc = res.data.img
            this.link = res.data.miniprogram_url
            this.btnImgSrc = res.data.button_img
          }
        } catch (error) {
          console.log(error)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .page{
    width: 100vw;
    // height: 100vh;
    box-sizing: border-box;
  }
  #launch-btn{
    position: absolute;
    top: 0;
    left: 0;
    right:0;
    bottom: 0;
    z-index: 999;
    opacity: 1;
  }
  img {
    -webkit-touch-callout : none;
  }
  .footer-btn-box {
    width: 100%;
    background: #fff;
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 12px 24px;
    >img {
      width: 100%;
    }
  }
</style>
